import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

const ScrollToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className={`fixed bottom-8 right-8 z-[150] transition-all duration-300 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'}`}>
      <button
        onClick={scrollToTop}
        aria-label="Scroll to top"
        className="group relative flex items-center justify-center w-14 h-14 bg-[#0F1419]/80 backdrop-blur-md border-2 border-[#059669] hover:border-[#FF6B35] rounded-2xl shadow-2xl transition-all duration-300 hover:scale-110 active:scale-95 cursor-pointer"
      >
        <div className="absolute inset-0 bg-[#059669]/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <ArrowUp className="w-7 h-7 text-[#059669] group-hover:text-[#FF6B35] transition-colors duration-300" strokeWidth={3} />
        
        {/* Subtle label that appears on hover */}
        <span className="absolute right-full mr-4 bg-[#0F1419] border border-white/10 text-white text-[10px] font-black uppercase tracking-widest px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap">
          Back To Top
        </span>
      </button>
    </div>
  );
};

export default ScrollToTop;